import type { Flow } from "@learnengine/shared-types";
import { AudioController } from "./AudioController";

/**
 * SyncManager coordinates Timeline → Audio.
 * Phase 2 goal: audio is optional and never blocks visuals.
 */
export class SyncManager {
  constructor(private readonly audio: AudioController) {}

  loadFlow(flow: Flow) {
    this.audio.loadFlow(flow);
  }

  onPlay() {
    this.audio.play();
  }

  onPause() {
    this.audio.pause();
  }

  onSeek(timeSeconds: number) {
    // For mock audio, always hard-seek to the same time.
    this.audio.seek(timeSeconds);
  }

  onTick(timeSeconds: number) {
    this.audio.update(timeSeconds);
  }
}
